import styles from '../account.module.scss'
import cl from 'classnames'
import { observer } from 'mobx-react-lite'
import { PageContainer, PageHeader } from '@touche-lts/panel-ui/dist'
import { IconPayment, IconTrash } from 'assets/icons'
import { useEffect } from 'react'
import { useRootStore } from 'mobx-stores/store-provider'
import { CredicCardsDTO } from 'models'
import { formatHTMLCardNumber, getCardTypeImg } from "utilities"
 
const AccountPaymentComponent = (props) => {
    const {
        accountStore: {
            getCreditCards,
            creditCardsDetails,
            deleteCreditCard
        },
    } = useRootStore(),

    userDetailsId = JSON.parse(localStorage.getItem('userDetails'))?.id

    useEffect(()=> {
        if(userDetailsId) {
            getCreditCards(userDetailsId)
        }
    }, [getCreditCards, userDetailsId])

    return (
    <PageContainer className={cl(styles.scrollable, 'container')} style={{marginTop: 80, overflow: 'visible'}}>
        <PageHeader
            navSegments={[
            {
                icon: IconPayment,
                label: 'Payment methods',
            }
            ]}
            style={{position: 'static', marginTop: 'auto'}}
            colorPreset='dark'
        />     
        <div className="d-flex text-secondary">My saved cards</div>
        <div className="d-flex flex-wrap">
            {creditCardsDetails && creditCardsDetails.map((card: CredicCardsDTO) => {
                return (
                    <div className={styles.cardBox}>
                        <div className="d-flex justify-content-between">
                            <h2>{card?.name}</h2>
                            <div className={styles.cardTopContent}>
                                <div className={styles.cardLogo}>
                                    <img src={getCardTypeImg(card?.cardType)} alt="issuerLogo" />
                                </div>
                                <div className={styles.cardDelete}>
                                    <IconTrash fill={styles.white} onClick={() => deleteCreditCard(userDetailsId, card?.id)} />
                                </div>
                            </div>
                        </div>
                        <div className="d-flex flex-column align-items-start pt-3">
                            <p>Card Number</p>
                            <p dangerouslySetInnerHTML={formatHTMLCardNumber(card?.number)} className="pt-3 text-white"></p>
                        </div>
                        <div className="d-flex flex-column align-items-start pt-3">
                            <p>Expiration Date</p>
                            <p className="pt-2">{new Date(card?.expDate).toLocaleDateString()}</p>
                        </div>
                    </div>
                )
            })}
        </div>
    </PageContainer>
    )
},

AccountPayment = observer(AccountPaymentComponent)
export { AccountPayment }
